import { defineComponent as _defineComponent } from 'vue'
import Spinner from "@/components/common/Spinner.vue";
import { formatPrice, USDC_MINT } from "@/shared";
import { IToken } from "@/shared/interfaces";
import {
	watch,
	computed,
	ref,
	onMounted,
} from "vue";

// props
interface IProps {
	token: IToken;
	readonly?: boolean;
	selectDisabled?: boolean;
	loading?: boolean;
	lastPrice: number;
}
interface IEmits {
	(e: "selectToken"): void;
	(e: "updatePrice", { token, price }: { token: IToken; price: number }): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TokenSelectNext',
  props: {
    token: null,
    readonly: { type: Boolean },
    selectDisabled: { type: Boolean },
    loading: { type: Boolean },
    lastPrice: null
  },
  emits: ["selectToken", "updatePrice"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "selectToken"): void;
	(e: "updatePrice", { token, price }: { token: IToken; price: number }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	token: IToken;
	readonly?: boolean;
	selectDisabled?: boolean;
	loading?: boolean;
	lastPrice: number;
};



// data
const price = ref<number>(0);
const currentToken = ref<string>();

// methods

function setPrice(p: number): void {
	price.value = p;
	emit("updatePrice", { token: props.token, price: price.value });
}
function reset(): void {
	currentToken.value = props.token.address?.toString();
	price.value = 0;
}
function emitSelect(e: MouseEvent) {
	(e.target as HTMLInputElement).select();
}

//computed
const priceUSD = computed<number>(() => {
	if(currentToken.value === USDC_MINT)
		return price.value

	return props.lastPrice * price.value;
});

// watch
watch(
	() => props.token,
	() => {
		if (props.token.address?.toString() === currentToken.value) return;

		reset();
	},
	{ deep: true }
);

onMounted(() => {
	currentToken.value = props.token.address?.toString();
});

// emits


// expose
expose({ setPrice, price: price, reset });

return { __sfc: true,props, price, currentToken, setPrice, reset, emitSelect, priceUSD, emit, Spinner, formatPrice }
}

})